import { get } from 'lodash';
import { EmailValidation } from 'src/lib/validation/ValidationTypes';
import { isTrue } from 'src/utils/helper';
import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';

// import schemas
import OrganisationSchema from 'src/lib/paths/organisation_FULL_Paths.json';
let P = OrganisationSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const OrganisationDataHochschuleValidator = (_orgaDaten: any) => {
	const newSchema = new Schema({
		//
		// ORGANISATIONSPROFIL
		//
		[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
			type: String,
			required: true,
		},
		[P.Unternehmensprofil_Zeichnungsberechtigte.path]: {
			each: {
				Anrede: {
					type: String,
				},
				Titel: {
					type: String,
				},
				Vorname: {
					type: String,
					required: true,
				},
				Nachname: {
					type: String,
					required: true,
				},
				Funktion: {
					type: String,
				},
				E_45_Mail_45_Adresse: {
					required: true,
					...EmailValidation,
				},
				Telefonnummer: {
					type: String,
					required: true,
					use: {
						phone: (val: string) => /^[0-9\s]*$/.test(val),
					},
					message: {
						phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
					},
				},
			},
		},
		//
		// ADRESSDATEN
		//
		[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
			type: String,
		},
		[P.Adressdaten_Adresszusatz.path]: {
			type: String,
		},
		[P.Adressdaten_PLZ.path]: {
			type: String,
			// required: true,
			// use: {
			// 	postalCode: (val: string) => isPostalCode(val, 'DE'),
			// },
			// message: {
			// 	postalCode: 'Diese Postleitzahl ist ungültig.',
			// },
		},
		[P.Adressdaten_Ort.path]: {
			type: String,
			// required: true,
		},
		// ABweichender Sitz
		[P.Adressdaten_Abweichender_Sitz.path]: {
			type: Boolean,
		},
		// Weitere Felder für Abweichender Sitz werden unten dynamisch hinzugefügt.
		/**
		 * BITTE ZUERST LESEN
		 */
		// Diese Daten werden aus verknüpfte Hochschulprofil gezogen und sind daher nicht editierbar.
		// [P.Adressdaten_Landkreis_Kreisfreie_Stadt.path]: {
		// 	type: String,
		// 	required: true,
		// },
		//
		// KONTAKTDATEN DER ORGANISATION
		//
		[P.Kontaktdaten_E_Mail.path]: {
			type: String,
			required: true,
			use: { mailValidator },
			message: {
				mailValidator: 'Ungültige E-Mail-Adresse.',
			},
		},
		[P.Kontaktdaten_Fax.path]: {
			type: String,
		},
		[P.Kontaktdaten_Telefon.path]: {
			type: String,
			required: true,
			use: {
				phone: (val: string) => /^[0-9\s]*$/.test(val),
			},
			message: {
				phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
			},
		},
		[P.Kontaktdaten_Webadresse.path]: {
			type: String,
		},

		//
		// MAILBENACHRICHTIGUNGEN
		//
		[P.Mailbenachrichtungen_Mail.path]: {
			each: {
				Mailbenachrichtungen_Mail: {
					type: String,
					required: true,
					use: { mailValidator },
					message: {
						mailValidator: 'Ungültige E-Mail-Adresse.',
					},
				},
			},
		},
		[P.Organisationsprofil_Vollstaendig.path]: {
			type: Boolean,
			required: true,
		},
	});

	const isAbweichenderSitz = get(_orgaDaten, P.Adressdaten_Abweichender_Sitz.path, false);
	if (isTrue(isAbweichenderSitz)) {
		newSchema.path(P.Adressdaten_Abweichender_Sitz_Adresse_Strasse_Und_Hausnummer.path).required(true);
		newSchema.path(P.Adressdaten_Abweichender_Sitz_Adresse_PLZ.path).required(true);
		newSchema.path(P.Adressdaten_Abweichender_Sitz_Adresse_Ort.path).required(true);
	}

	newSchema.message({
		required: (_path: string) => 'Pflichtfeld.',
		type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
	});

	return newSchema;
};

export default OrganisationDataHochschuleValidator;
